import { FileText } from 'lucide-react';

export function MeetingModeButton({
  t,
  lang,
  active,
  live,
  onClick,
}: {
  t?: any;
  lang: 'en' | 'zh';
  active: boolean;
  live: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex min-w-[156px] items-center justify-center gap-2 rounded-2xl border px-3 py-2 text-xs font-black uppercase tracking-[0.16em] transition-all ${
        active
          ? 'border-cyan-400/30 bg-cyan-400/15 text-cyan-100 shadow-[0_12px_32px_rgba(34,211,238,0.12)]'
          : 'border-white/10 bg-white/[0.035] text-white/45 hover:bg-white/[0.075] hover:text-white/75'
      }`}
      title={t?.modeMeetingTitle || (lang === 'zh' ? '会议模式' : 'Meeting mode')}
    >
      <span className={`h-2 w-2 rounded-full ${live ? 'bg-cyan-300 animate-pulse' : active ? 'bg-cyan-300' : 'bg-white/25'}`} />
      <FileText size={14} />
      <span>{t?.modeMeeting || (lang === 'zh' ? '会议' : 'Meeting')}</span>
    </button>
  );
}
